import { useState } from 'react';

const useLocalStorageState = (key, initialValue) => {
    const [state, setState] = useState(() => {
        // Initialize the state
        try {
            let value = '';
            if (typeof window !== 'undefined') {
                value = window.localStorage.getItem(key) || '';
            }
            // Check if the local storage already has any values,
            // otherwise initialize it with the passed initialValue
            if (value) {
                return JSON.parse(value);
            }

            if (typeof window !== 'undefined' && typeof initialValue !== 'undefined') {
                window.localStorage.setItem(key, JSON.stringify(initialValue));
            }
            return initialValue;
        } catch {
            console.log('Error getting local storage value');
        }
    });

    const setValue = (value) => {
        try {
            // If the passed value is a callback function,
            //  then call it with the existing state.
            if (typeof window !== 'undefined') {
                const valueToStore = value instanceof Function ? value(state) : value;
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
                setState(value);
            }
        } catch {
            console.log('Error setting local storage value');
        }
    };

    const clearValue = () => {
        try {
            if (typeof window !== 'undefined') {
                window.localStorage.removeItem(key);
            }
            setState(null);
        } catch {
            console.log('Error clearing local storage');
        }
    };

    return { state, setValue, clearValue };
};

export default useLocalStorageState;
